import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Article, Watchlist } from '../../core/models';
import { Company } from '../../core/models';
import { LayoutService } from '../../modules/layout';
import { ActivatedRoute } from '@angular/router';
import {
  loadCompanyById,
  resetSelectedCompany,
} from '../../core/store/company/company.actions';
import { select, Store } from '@ngrx/store';
import { getSelectedCompany } from '../../core/store/company/company.selectors';
import { AppState } from '../../core/store/app.state';
import { loadWatchlistByCompanyId } from '../../core/store/watchlist/watchlist.actions';
import { getSelectedWatchlist } from '../../core/store/watchlist/watchlist.selectors';
import { loadPortfolioByCompanyId } from '../../core/store/portfolio/portfolio.actions';
import { getSelectedPortfolio } from 'src/app/core/store/portfolio/portfolio.selectors';
import { getNextTenArticles } from '../../core/store/article/article.selectors';
import * as ArticleActions from '../../core/store/article/article.actions';

type Nullable<T> = T | null;

@Component({
  selector: 'app-company-page',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit, OnDestroy {
  selectedId: Nullable<number> = null;
  firstSpotlightNews$: Observable<Article[]> = this.store.pipe(
    select(getNextTenArticles)
  );
  company$: Observable<Company | null> = this.store.pipe(
    select(getSelectedCompany)
  );
  watchlist$: Observable<Watchlist | null> = this.store.pipe(
    select(getSelectedWatchlist)
  );
  portfolio$: Observable<Watchlist | null> = this.store.pipe(
    select(getSelectedPortfolio)
  );
  private paramsSub: Subscription;
  constructor(
    private readonly layout: LayoutService,
    private route: ActivatedRoute,
    private readonly store: Store<AppState>
  ) {
    this.layout.hideHeader();
  }
  ngOnInit(): void {
    this.paramsSub = this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.selectedId = Number.parseInt(id);
        this.store.dispatch(loadCompanyById({ id: this.selectedId }));
        this.store.dispatch(
          loadWatchlistByCompanyId({ id_company: this.selectedId })
        );
        this.store.dispatch(
          loadPortfolioByCompanyId({ id_company: this.selectedId })
        );

        this.store.dispatch(
          ArticleActions.loadArticles({
            page: 1,
            limit: 25,
          })
        );
      }
    });
  }
  ngOnDestroy(): void {
    this.layout.showHeader();
    this.store.dispatch(resetSelectedCompany());
    this.paramsSub.unsubscribe();
  }
}
